import { createContext, useContext, useEffect, useState } from "react";
import freePlanClient from "../config/freePlanClient";
const DataContext = createContext();

export const useData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const [days, setDays] = useState(0);

  useEffect(() => {
    const clientRes = async () => {
      try {
        const Res = await freePlanClient.get("/freeplan");
        const Data = Res?.data?.data;
        // console.log("Free Client", Data);
        const days = Data?.no_days_for_free_usage;
        // console.log("Free Client", days);
        setDays(days ?? 14);
      } catch (e) {
        console.error("Failed to fetch free plan days", e);
        setDays(14);
      } finally {
        setLoading(false);
      }
    };
    clientRes();
  }, []);

  return (
    <DataContext.Provider value={{ days, loading }}>
      {children}
    </DataContext.Provider>
  );
};
